export default "__VITE_ASSET__b02defad__"